import React from 'react';
import { SparklesIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const HOTMART = 'https://checkout.recursostop.shop/cart/45816556028100:1';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  return <section className="relative bg-[#0f0f1a] text-white py-14 md:py-20 px-4 overflow-hidden border-t border-white/5" data-id="element-131">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#c82333]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-132"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-3xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-133">
        <div className="mb-6" data-id="element-134">
          <SparklesIcon className="w-8 h-8 text-[#d4a017] mx-auto mb-4 animate-pulse" data-id="element-135" />
        </div>

        <div className="space-y-4 text-xl md:text-2xl text-gray-300 font-light leading-relaxed max-w-2xl mx-auto mb-8" data-id="element-136">
          <p className="text-[#f0c040] font-serif italic text-2xl md:text-3xl" data-id="element-137">
            ✨ Puedes seguir buscando respuestas sueltas…
          </p>
          <p className="font-medium text-white text-2xl md:text-3xl font-serif" data-id="element-138">
            O puedes formarte correctamente.
          </p>
        </div>

        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight text-white" data-id="element-139">
          Sana tu vida.
          <br data-id="element-140" />
          Aprende una habilidad real.
          <br data-id="element-141" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4a017] via-[#f0c040] to-[#d4a017]" data-id="element-142">
            Construye una nueva oportunidad.
          </span>
        </h2>

        <div className="w-full max-w-xl mx-auto" data-id="element-143">
          <a href="#pricing-offer" className="w-full block px-6 py-4 md:py-5 rounded-xl text-white font-bold text-base sm:text-lg md:text-2xl tracking-widest uppercase transition-all shadow-[0_0_30px_rgba(200,35,51,0.4)] hover:shadow-[0_0_40px_rgba(200,35,51,0.6)] hover:-translate-y-1 bg-[#c82333] hover:bg-[#bd2130] border border-red-500/50" style={{
          fontFamily: "'Cormorant Garamond', serif",
          letterSpacing: '0.1em'
        }} data-id="element-144">
            💚 QUIERO ACCEDER AL CURSO INTEGRAL REIKI
          </a>
          <p className="text-gray-400 text-sm mt-4 font-medium" data-id="element-145">
            Acceso inmediato. Empieza hoy.{' '}
            <span className="text-[#f0c040] font-bold" data-id="element-146">
              💳 Hasta 3 cuotas sin interés
            </span>
          </p>
        </div>
      </div>
    </section>;
}